'use client';

import { useIsDesktop } from '@/_hooks/useBreakpoint';

import Desktop from './responsive/desktop';
import Mobile from './responsive/mobile';

const Profile = () => {
  const isDesktop = useIsDesktop();

  return isDesktop ? <Desktop /> : <Mobile />;
};

export default Profile;
